import { useClickAway } from '@uidotdev/usehooks';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { Archive_count } from '../../graphql/GraphqlQueries';
import { useSelector, useDispatch } from 'react-redux';
import { set_workFreelitheme } from '../../redux/message';
import { useTheme } from '../../context/ThemeContext';
import { Logout } from '../../graphql/GraphqlMutation';
import { useMutation } from '@apollo/client';

const _isLinux = navigator.userAgent.toLowerCase().includes('linux');
const _NATIVE_APP_URL = _isLinux
    ? 'https://wfss001.freeli.io/common/freeli-call.deb'
    : 'https://wfss001.freeli.io/common/freeli-call.exe';
const _NOTIFIER_NODE_URL = process.env.REACT_APP_NOTIFIER_NODE_URL || 'https://wfss001.freeli.io/common/FreeliNotifier-1.0.0.zip';
const _NOTIFIER_GO_URL = process.env.REACT_APP_NOTIFIER_GO_URL || 'https://wfss001.freeli.io/common/FreeliNotifier-Go-1.0.0.zip';


const SettingsOptions = ({ setSettingOptionsPopup, handleChangePasswordPopup, setTipsAndTour, setArchiveRoom, getArchiveConversations, companiesData, setTitleText, setComingSoon, deferredPrompt,
  setDeferredPrompt, handleChangeModulePasswordPopup, setDesktopWizard, setSidebarOpen }) => {
  const dispatch = useDispatch();
  const ref1 = useClickAway(() => {
    setSettingOptionsPopup(false)
  });

  const [common_res] = useMutation(Logout);

  const logout = async () => {

    const xmpp_token = localStorage.getItem('xmpp_tokenid');
    const isTrusted = localStorage.getItem('isTrusted');

    const remove_device = isTrusted === 'yes' ? 'no' : 'yes';
    const final_remove_device = isTrusted ? remove_device : 'no';

    const res = await common_res({
      variables: {
        input: {
          remove_device: final_remove_device,
          xmpp_token: xmpp_token,
          device_type: 'web',
          fcm_token: window.firebase_token || "",
        },
      },
    });

    if (res?.data?.logout?.status) {
      localStorage.clear();
      window.location.href = '/';
    }
  };


  const userMe = useSelector(state => state.message.user);
  const { selectTheme, themeMode } = useTheme();

  const handleLightMood = () => {
    selectTheme('light');
    dispatch(set_workFreelitheme('light'))
    setSettingOptionsPopup(false)
  }

  const handleDarkMood = () => {
    selectTheme('dark')
    dispatch(set_workFreelitheme('dark'))
    setSettingOptionsPopup(false)
  }

  const handleTipsPopup = () => {
    setSettingOptionsPopup(false)
    setTipsAndTour(true)
  }

  const handleArchiveRoom = () => {
    getArchiveConversations()
    setSettingOptionsPopup(false)
    setArchiveRoom(true)
  }

  const [archiveCounter, setArchiveCounter] = useState(0)

  useQuery(Archive_count, {
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      console.log("🚀 ~ SettingsOptions ~ data:", data)
      if (data?.archive_count?.status) {
        setArchiveCounter(data?.archive_count?.archive)
      }
    },
    onError: (error) => {
      console.log("🚀 ~ file: SettingsOptions.js ~ line 72 ~ getArchiveCount ~ error", error)
    }
  })

  // Send auth credentials to the local freeli-notifier service (if running)
  const sendAuthToNotifier = async () => {
        const authToken = localStorage.getItem('token');
        if (!authToken || !userMe?._id) return;
        try {
            await fetch('http://127.0.0.1:49152/auth', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    userId:       userMe._id,
                    authToken,
                    userFullname: userMe.fullname || `${userMe.first_name || ''} ${userMe.last_name || ''}`.trim(),
                    graphqlUrl:   process.env.REACT_APP_BASE_URL + '/workfreeli',
                    webAppOrigin: window.location.origin,
                    xmppDomain:   process.env.REACT_APP_XMPP_DOMAIN || '',
                }),
            });
        } catch { /* notifier not running — silent */ }
    };

  const clicktoAddShortcut = () => {
    // setSettingOptionsPopup(false);
    //     setDesktopWizard(true);
        if (window.deferredPrompt1) {
            window.deferredPrompt1.prompt();
            window.deferredPrompt1.userChoice.then((choiceResult) => {
                // Once the user chooses (accepted or dismissed), the prompt is gone.
                if (choiceResult.outcome === 'accepted') {
                    console.log('User accepted the install prompt');
                } else {
                    console.log('User dismissed the install prompt');
                }

                window.deferredPrompt1 = null;
                // Hide the button after the user interacts with the prompt
                setDeferredPrompt(false);
            });
        }
    };

  return (
    <>
      <div ref={ref1} className="profilenavMainSection !z-[999999] !display-[unset] md:left-[265px] md:top-[60px] lg:left-[315px] lg:top-[60px] xl:left-[393px] xl:top-[70px]" >
        <div className="profilenavMidleArea">
          <p className="profilenavMidleArea_label">Account details</p>
          <Link to='/connect/profile' title='Edit profile' onClick={() => { setSettingOptionsPopup(false); setSidebarOpen(o => !o) }} className="linkAccount">Edit profile</Link>
          <span className="linkAccount" onClick={() => { handleChangePasswordPopup(); setSidebarOpen(o => !o) }}>Change password</span>
          {userMe?.erpNextPass && userMe?.erpNextPass !== "" &&
            <span className="linkAccount" onClick={() => { handleChangeModulePasswordPopup(); setSidebarOpen(o => !o) }}>Module access password</span>
          }
          {/* <div className="profileNavContainer_line"></div> */}

          {/* <p className="profilenavMidleArea_label">Manage account</p> */}
          {
            companiesData?.companies?.length > 1 &&
            <Link to='/connect/switch-account' title='Switch accounts' onClick={() => { setSettingOptionsPopup(false); setSidebarOpen(o => !o) }} className="linkAccount">Switch accounts</Link>
          }
          <span className="linkAccount theme">Switch theme

            {/* <span className={`themeMode ${theme === 'light' ? 'active' : ''}`} onClick={handleLightMood}>Light mode</span>
              <span className={`themeMode ${theme === 'dark' ? 'active' : ''}`} onClick={handleDarkMood}>Dark mode</span> */}
            <span className="themeMenu">
              <span
                className={`themeMode ${themeMode === 'light' ? 'active' : ''}`}
                onClick={handleLightMood}
              >
                Light mode
              </span>
              <span
                className={`themeMode ${themeMode === 'dark' ? 'active' : ''}`}
                onClick={handleDarkMood}
              >
                Dark mode
              </span>
            </span>
          </span>
          {/* <Link to='/connect/theme-customizer' title='Theme customize' onClick={() => setSettingOptionsPopup(false)} className="linkAccount">Theme customize</Link> */}
          <div className="profileNavContainer_line"></div>
          <p className="profilenavMidleArea_label">Advanced</p>
          <Link to='/connect/notifications' title='All notifications' onClick={() => { setSettingOptionsPopup(false); setSidebarOpen(o => !o) }} className="linkAccount">All notifications</Link>
          {archiveCounter > 0 &&
            <span className="nodecoration">
              <span onClick={() => { handleArchiveRoom(); setSidebarOpen(o => !o) }} className="linkAccount">Archived rooms ({archiveCounter})</span>
            </span>
          }
          {/* <span className="nodecoration">
            <span className="linkAccount"><span>Manage Personal Tags</span></span>
          </span> */}
          {/* {["maher@ohs.global", "anwar@ohs.global", "msrkhokoncse@gmail.com"].includes(userMe.email) ?
            <Link to='/connect/workfreeli-ai' title='Admin settings' onClick={() => setSettingOptionsPopup(false)} className="linkAccount"> Hayven AI</Link> : ""} */}
          {/* {["maher@ohs.global", "anwar@ohs.global", "msrkhokoncse@gmail.com"].includes(userMe.email) ?
            <Link to='/connect/workfreeli-db' title='Hayven DB' onClick={() => setSettingOptionsPopup(false)} className="linkAccount"> Hayven DB</Link> : ""} */}
          {/* <Link to='/connect/s-loader' title='Workfreeli DB' className="linkAccount">S loader</Link> */}
          <Link to='/connect/mcp' title='AI Assistant' onClick={() => { setSettingOptionsPopup(false); setSidebarOpen(o => !o) }} className="linkAccount">AI Assistant</Link>
          {userMe.role === "Admin" && (<Link to='/connect/admin-settings' title='Admin settings' onClick={() => { setSettingOptionsPopup(false); setArchiveRoom(false); setSidebarOpen(o => !o) }} className="linkAccount">Admin settings</Link>)}
          <div className="profileNavContainer_line"></div>
          <p className="profilenavMidleArea_label">Help</p>
          {deferredPrompt ?
            <span className="nodecoration" onClick={clicktoAddShortcut}>
              <span className="linkAccount">
                {deferredPrompt ? 'Install PWA application' : ''}
              </span>
            </span> : ''}

          <span className="nodecoration" onClick={() => { setSettingOptionsPopup(false); setDesktopWizard(true); setSidebarOpen(o => !o) }} title="Set up Freeli Desktop for call alerts in any app">
            <span className="linkAccount">Setup freeli call app</span>
          </span>
          {/* <span className="nodecoration" onClick={downloadNotifierPackage} title="Download desktop notifier installer package">
            <span className="linkAccount">Download call notifier installer</span>
          </span> */}

          <span className="linkAccount" onClick={() => { handleTipsPopup(); setSidebarOpen(o => !o) }}>Tour for tips and suggestions</span>
          <span className="nodecoration">
            <span className="linkAccount" onClick={() => { setTitleText('Workfreeli support'); setComingSoon(true); setSidebarOpen(o => !o) }}><span>Workfreeli support</span></span>
          </span>
        </div>
        <div className="profileNavContainer_line"></div>
        <span className="linkAccount signout">Sign out
          <span className="signout_menu">
            <span className="themeMode border_bottom" onClick={() => logout()}>From this device</span>
          </span>
        </span>
      </div>

    </>
  );

};

export default SettingsOptions;
